<template>
  <div class="protocol login-protocol">
    <navigation>《委托划扣授权书》</navigation>
    <section class="content">
      <p class="text tab-2 fz24">授权人:</p>
      <p class="text tab-2 fz24">身份证号：</p>
      <p class="text tab-2 fz24">联系方式：</p>

      <p class="text tab-2 fz24">被授权单位一：重庆领易付科技有限公司</p>
      <p class="text tab-2 fz24">统一社会信用代码：91500103MAABTMTU3W</p>

      <p class="text tab-2 fz24">被授权单位二：深圳市万恒科技有限公司</p>
      <p class="text tab-2 fz24"> 统一社会信用代码：914403005856024954</p>
      <p class="text tab-2 fz24">（被授权单位一及被授权单位二，统称为“被授权单位”）</p>

      <p class="text tab-2"> 为保障各方合法权益，<b>本人不可撤销地授权并同意：被授权单位及其指定的第三方支付公司及/或银行可以从授权人绑定在天美贷平台的银行账户内划扣收本人依据“会员礼包”相关协议或使用“会员礼包”服务产生的应付款项，届时无需获得本人的同意也无需事先通知本人。本人同意被授权单位可指定任何有资质的第三方支付公司、银行从本人上述绑定账户中进行扣划，包括不限于：宝付网络科技（上海）有限公司等。</b></p>

      <p class="text tab-2"><b>本人承诺</b>：本人将承担因上述绑定账户余额不足或被查封冻结以及其他不可归责于被授权单位的事由导致无法按时足额扣款或扣款错误而导致的任何法律责任。若本人变更上述绑定扣款账户并经被授权单位认可，本授权书对本人变更后的账户继续有效。未经被授权单位书面同意，本授权书不得变更、撤销、解除或终止。本授权书自签署之日起生效，直至本人清偿所有款项或被授权单位书面通知本授权书失效之日方告失效。</p>

      <p class="text tab-2"><b>本人知晓并承诺</b>：被授权单位指定的第三方支付公司或银行依据本授权书进行的委托扣款操作引起的一切法律纠纷或风险，由授权人独立承担或解决。</p>
      <p class="text tab-2">本人知晓此份授权书是用户开通委托划扣的必备法律文件之一，并保证本授权书所提供的各项资料均准确无误、真实合法，没有提供任何虚假信息。</p>
      <p class="text tab-2"><b>授权人已阅读上述全部内容并同意相关条款，请点击“同意”按钮或签名或勾选，本授权立即生效，若授权人不同意授权，请立即停止操作，退出本申请页面。</b></p>

      <p class="text tab-2"> 授权人：</p>
      <p class="text tab-2"> 日期：    年   月   日</p>
      <p
        data-sensors-exposure-property-page_status="page_bottom"
        data-sensors-exposure-event-name="general_event"
      >&nbsp;<!-- 监听协议滑动到了底部，每个协议都加上--></p>
    </section>
  </div>
</template>

<script>
export default {
  name: 'deductionProtocol',
  created () {
    this.$bus.$emit('ready')
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.login-protocol {
  background-color: white;
  .fz24 {font-size: 24px !important;}
  .content {
    padding: 0 48px;
    .title {
      font-weight: bolder;
      color: #333333;
      font-size: 28px;
      text-indent: 40px;
      line-height: 44px;
      margin-top: 10px;
    }
    .text {
      color: #333333;
      font-size: 28px;
      text-indent: 40px;
      line-height: 44px;
    }
    .text:last-child {
      margin-bottom: 10px;
    }
    .underline {
      text-indent: 40px;
      font-weight: bold;
      text-decoration: underline;
    }
    .underline:last-child {
      margin-bottom: 10px;
    }
  }
}
</style>
